---
meta:
  - title: Cuándo usar un agente - IUSPRO Docs
  - description: Aprenda cuándo conviene usar agentes y cuándo basta con trabajar en Auri o en Redactor.
---

# Cuándo usar un agente

No todo trabajo necesita un agente.

Muchas veces, una buena conversación en Auri o una instrucción clara en Redactor es suficiente.

## Conviene usar un agente cuando

Úselo cuando:

- hace el mismo tipo de trabajo una y otra vez
- suele seguir un orden parecido al estudiar y redactar
- quiere dejar una forma de trabajo lista para repetirla
- otras personas del despacho también deberían poder usar ese mismo criterio
- le interesa conservar el historial completo de cada ejecución

## No conviene usar un agente cuando

Probablemente no hace falta cuando:

- tiene una duda puntual
- todavía está pensando la estrategia
- necesita conversar mucho e ir corrigiendo sobre la marcha
- cada caso cambia tanto que no vale la pena dejar un flujo fijo

## ¿Por qué no basta con una instrucción larga?

Porque una instrucción muy larga suele mezclar demasiadas cosas:

- los hechos
- el objetivo
- el análisis
- la investigación
- la redacción
- la revisión

Cuando todo eso va junto, es más difícil repetir el trabajo con el mismo criterio.

El agente ayuda a separar el trabajo en partes más claras.

## Casos donde sí conviene

- generar un primer análisis y luego una demanda laboral
- revisar contratos con el mismo criterio una y otra vez
- preparar respuestas registrales siguiendo siempre el mismo orden
- redactar un escrito y dejar lista una traducción

## Casos donde no conviene

- una consulta rápida sobre un artículo
- una duda puntual de estrategia
- una conversación abierta donde todavía no sabe qué documento necesita

## Regla práctica

Si usted piensa:

> “Este trabajo lo hago seguido y casi siempre lo resuelvo de manera parecida”

entonces probablemente sí conviene un agente.

Si piensa:

> “Aquí necesito conversar, probar ideas y moverme libremente”

entonces probablemente conviene empezar en Auri o Redactor.

## Siguiente lectura

- Vea [cómo crear un agente](/guias/agentes-como-crear)
- Entienda [cómo funciona cada parte del agente](/guias/agentes-como-funciona-cada-paso)
